import { FilterOperator } from './FilterOperator';
import { JunctionOperator } from './JunctionOperator';

export class SearchCriterion {

    constructor(public field: string, public value: any,
        public operator: FilterOperator,
        public junctionOperator: JunctionOperator = JunctionOperator.And,
        public isCaseSensitive: boolean = false) {
    }

}